let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7sleH"), load("93dCk"), load("6XNSn")]).then(() => parcelRequire('2SLpl'));